import React from "react";

export default function Footer() {
  return (
    <div title="footer" role="navigation">
      <div className="navigation hide-mobile footer">
        <div className="flexible section-button nav-link">
          <a className="" href="/art">
            <div className="top-nav">Art</div>
            <p className="top-nav-supporting">View Exhibitions</p>
          </a>
        </div>
        <div className="flexible section-button nav-link">
          <a href="/travel" className="">
            <div className="top-nav">Travel</div>
            <p className="top-nav-supporting">Go Places</p>
          </a>
        </div>
        <div className="flexible section-button nav-link">
          <a className="" href="/hotel">
            <div className="top-nav">Hotel</div>
            <p className="top-nav-supporting">Rest Well</p>
          </a>
        </div>
        <div className="flexible section-button nav-link">
          <a className="" href="/private-events">
            <div className="top-nav">Private Events</div>
            <p className="top-nav-supporting">Book The Battery</p>
          </a>
        </div>
      </div>
      <div className="footer-bottom navigation-footer">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 60
          }}
        >
          <img
            src="https://thebatterysf-production.sfo3.cdn.digitaloceanspaces.com/static/v3/SVG/BAT_logo_square.svg"
            alt="The Battery Logo"
            width="80"
            height="90"
            style={{ marginRight: 60 }}
          />
          <div>
            <div className="footer-content block-date">415-230-8000</div>
            <div className="footer-content top-nav-supporting">717 Battery Street, SF, CA</div>
            <div className="footer-content">
              <a href="mailto:guru@thebatterysf.com">guru@thebatterysf.com</a>
            </div>
          </div>
        </div>
        <div className="footer-links">
          <div className="footer-link">
            <a href="/about">About</a>
          </div>
          <div className="footer-link">
            <a href="/careers">Careers</a>
          </div>
          <div className="footer-link">
            <a href="/press">Press</a>
          </div>
          <div className="footer-link">
            <a href="/privacy-policy">Privacy Policy</a>
          </div>
          <div className="footer-link">
            <a href="/charter">Charter</a>
          </div>
        </div>
        <div className="footer-social">
          <a href="https://www.facebook.com/thebatterysf">
            <svg
              aria-label="facebook"
              width="16px"
              height="16px"
              fill="currentColor"
              viewBox="0 0 30 24"
            >
              <path d="M21.5,7.9l-0.3,3.6h-3.7V24h-4.7V11.5h-2.5V7.9h2.5V5.5c0-1.1,0-2.7,0.8-3.7C14.5,0.7,15.6,0,17.5,0c3.1,0,4.4,0.4,4.4,0.4 l-0.6,3.7c0,0-1-0.3-2-0.3c-1,0-1.8,0.3-1.8,1.3v2.8H21.5z" />
            </svg>
          </a>
          <a href="https://twitter.com/thebatterysf">
            <svg
              aria-label="twitter"
              height="16px"
              width="16px"
              fill="currentColor"
              viewBox="0 0 30 24"
            >
              <path d="M26.7,6c0,0.3,0,0.5,0,0.8c0,8-6.1,17.2-17.2,17.2c-3.4,0-6.6-1-9.3-2.7c0.5,0.1,1,0.1,1.4,0.1c2.8,0,5.5-1,7.5-2.6 c-2.7,0-4.9-1.8-5.7-4.2c0.4,0.1,0.7,0.1,1.1,0.1c0.6,0,1.1-0.1,1.6-0.2c-2.8-0.6-4.9-3-4.9-5.9c0,0,0-0.1,0-0.1 c0.8,0.5,1.8,0.7,2.7,0.8c-1.6-1.1-2.7-2.9-2.7-5c0-1.1,0.3-2.2,0.8-3c3,3.7,7.5,6.1,12.5,6.3c-0.1-0.4-0.2-0.9-0.2-1.4 c0-3.3,2.7-6.1,6.1-6.1c1.7,0,3.3,0.7,4.4,1.9c1.4-0.3,2.7-0.8,3.8-1.5c-0.5,1.4-1.4,2.6-2.7,3.4c1.2-0.1,2.4-0.5,3.5-1 C29,4.1,27.9,5.1,26.7,6z" />
            </svg>
          </a>
          <a href="https://www.linkedin.com/company/the-battery">
            <svg
              aria-label="linkedin"
              fill="currentColor"
              viewBox="0 0 30 24"
              height="16px"
              width="16px"
            >
              <g>
                <rect x="2.6" y="7.7" width="5.1" height="16.3" />
                <path d="M5,5.7L5,5.7C3.2,5.7,2,4.4,2,2.8C2,1.2,3.2,0,5.1,0c1.9,0,3,1.2,3.1,2.8C8.2,4.4,7,5.7,5,5.7z" />
                <path d="M28.1,24h-5.8v-8.4c0-2.2-0.9-3.7-2.9-3.7c-1.5,0-2.4,1-2.8,2c-0.1,0.4-0.1,0.8-0.1,1.3V24h-5.7c0,0,0.1-14.9,0-16.3h5.7 v2.6c0.3-1.1,2.2-2.7,5.1-2.7c3.6,0,6.5,2.3,6.5,7.4V24z" />
              </g>
            </svg>
          </a>
          <a href="https://instagram.com/thebatterysf/">
            <svg
              aria-label="instagram"
              viewBox="0 0 504 504"
              height="16px"
              width="16px"
              version="1.1"
            >
              <path
                d="M251.921,0.159 C183.503,0.159 174.924,0.449 148.054,1.675 C121.24,2.898 102.927,7.157 86.903,13.385 C70.337,19.822 56.288,28.436 42.282,42.441 C28.277,56.447 19.663,70.496 13.226,87.062 C6.998,103.086 2.739,121.399 1.516,148.213 C0.29,175.083 0,183.662 0,252.08 C0,320.497 0.29,329.076 1.516,355.946 C2.739,382.76 6.998,401.073 13.226,417.097 C19.663,433.663 28.277,447.712 42.282,461.718 C56.288,475.723 70.337,484.337 86.903,490.775 C102.927,497.002 121.24,501.261 148.054,502.484 C174.924,503.71 183.503,504 251.921,504 C320.338,504 328.917,503.71 355.787,502.484 C382.601,501.261 400.914,497.002 416.938,490.775 C433.504,484.337 447.553,475.723 461.559,461.718 C475.564,447.712 484.178,433.663 490.616,417.097 C496.843,401.073 501.102,382.76 502.325,355.946 C503.551,329.076 503.841,320.497 503.841,252.08 C503.841,183.662 503.551,175.083 502.325,148.213 C501.102,121.399 496.843,103.086 490.616,87.062 C484.178,70.496 475.564,56.447 461.559,42.441 C447.553,28.436 433.504,19.822 416.938,13.385 C400.914,7.157 382.601,2.898 355.787,1.675 C328.917,0.449 320.338,0.159 251.921,0.159 Z M251.921,45.55 C319.186,45.55 327.154,45.807 353.718,47.019 C378.28,48.139 391.619,52.243 400.496,55.693 C412.255,60.263 420.647,65.722 429.462,74.538 C438.278,83.353 443.737,91.745 448.307,103.504 C451.757,112.381 455.861,125.72 456.981,150.282 C458.193,176.846 458.45,184.814 458.45,252.08 C458.45,319.345 458.193,327.313 456.981,353.877 C455.861,378.439 451.757,391.778 448.307,400.655 C443.737,412.414 438.278,420.806 429.462,429.621 C420.647,438.437 412.255,443.896 400.496,448.466 C391.619,451.916 378.28,456.02 353.718,457.14 C327.158,458.352 319.191,458.609 251.921,458.609 C184.65,458.609 176.684,458.352 150.123,457.14 C125.561,456.02 112.222,451.916 103.345,448.466 C91.586,443.896 83.194,438.437 74.379,429.621 C65.564,420.806 60.104,412.414 55.534,400.655 C52.084,391.778 47.98,378.439 46.86,353.877 C45.648,327.313 45.391,319.345 45.391,252.08 C45.391,184.814 45.648,176.846 46.86,150.282 C47.98,125.72 52.084,112.381 55.534,103.504 C60.104,91.745 65.563,83.353 74.379,74.538 C83.194,65.722 91.586,60.263 103.345,55.693 C112.222,52.243 125.561,48.139 150.123,47.019 C176.687,45.807 184.655,45.55 251.921,45.55 Z"
                fill="currentColor"
              />
              <path
                d="M251.921,336.053 C205.543,336.053 167.947,298.457 167.947,252.08 C167.947,205.702 205.543,168.106 251.921,168.106 C298.298,168.106 335.894,205.702 335.894,252.08 C335.894,298.457 298.298,336.053 251.921,336.053 Z M251.921,122.715 C180.474,122.715 122.556,180.633 122.556,252.08 C122.556,323.526 180.474,381.444 251.921,381.444 C323.367,381.444 381.285,323.526 381.285,252.08 C381.285,180.633 323.367,122.715 251.921,122.715 Z"
                fill="currentColor"
              />
              <path
                d="M416.627,117.604 C416.627,134.3 403.092,147.834 386.396,147.834 C369.701,147.834 356.166,134.3 356.166,117.604 C356.166,100.908 369.701,87.373 386.396,87.373 C403.092,87.373 416.627,100.908 416.627,117.604"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}
